import { render, staticRenderFns } from "./TireReferenceModelAddEffectiveDate.vue?vue&type=template&id=57a52620&"
import script from "./TireReferenceModelAddEffectiveDate.vue?vue&type=script&lang=js&"
export * from "./TireReferenceModelAddEffectiveDate.vue?vue&type=script&lang=js&"
import style0 from "./TireReferenceModelAddEffectiveDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports